import React, {FC, ReactElement} from 'react';
import {withStyles} from '@material-ui/core';

import {getDirectionStyles} from '../../utils/ThemeUtils';
import Tooltip from '../common/Tooltip';
import GameInfo from '../game-info/GameInfo';

const StyledTooltip = withStyles(theme => ({
    popper: {
        pointerEvents: 'none'
    },
    tooltip: {
        margin: 0,
        transform: `${getDirectionStyles(theme.direction)(
            'translate(-20px, calc(100% - 10px))',
            'translate(20px, calc(100% - 10px))'
        )} !important`
    }
}))(Tooltip);

export interface InfoTooltipProps {
    value: string;
    code: string;
    children: ReactElement;
}

const InfoTooltip: FC<InfoTooltipProps> = ({value, code, children}: InfoTooltipProps) => (
    <StyledTooltip placement="top-start" title={<GameInfo title={value} code={code} />}>
        {children}
    </StyledTooltip>
);

export default InfoTooltip;
